const AMPLITUDE_USER_ID_PREFIX = 'ssu_';

export const generateAmplitudeUserId = (userId: string) => `${AMPLITUDE_USER_ID_PREFIX}${userId}`;
